import { render } from "./TrustDeposit.vue?vue&type=template&id=5346db48"
import script from "./TrustDeposit.vue?vue&type=script&lang=js"
export * from "./TrustDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__